import { ProductStatus, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import {
    KeyValueObject,
    Privilege,
    TRANSLATION_TABLE_HEADER_CLIENT_NAME,
    TRANSLATION_TABLE_HEADER_CODE,
    TRANSLATION_TABLE_HEADER_PRODUCT_NAME,
    TRANSLATION_TABLE_HEADER_PRODUCT_TYPE,
    TRANSLATION_TABLE_HEADER_STATUS,
    WdxThemeColor,
} from '@wdx/shared/utils';
import { TableHeader } from '../../../models/table-header.model';

export const CLIENT_PRODUCTS_LISTING_ROUTE_DATA = {
    viewType: SystemEntity.ClientProduct,
    paginationOptions: { pageSize: 40 },
    dropdownMenuPrivileges: {
        export: Privilege.ExportClientProduct,
    },
};

export const CLIENT_PRODUCTS_LISTING_HEADERS: TableHeader[] = [
    {
        value: 'Product Name',
        translationKey: TRANSLATION_TABLE_HEADER_PRODUCT_NAME,
    },
    {
        value: 'Client Name',
        translationKey: TRANSLATION_TABLE_HEADER_CLIENT_NAME,
    },
    {
        value: 'Code',
        translationKey: TRANSLATION_TABLE_HEADER_CODE,
    },
    {
        value: 'Product Type',
        translationKey: TRANSLATION_TABLE_HEADER_PRODUCT_TYPE,
    },
    {
        value: 'Status',
        translationKey: TRANSLATION_TABLE_HEADER_STATUS,
    },
];

export const PRODUCT_STATUS_THEME_COLOR_MAP: KeyValueObject<WdxThemeColor> = {
    [ProductStatus.Active]: 'success',
    [ProductStatus.Blocked]: 'danger',
    [ProductStatus.Cancelled]: 'none',
    [ProductStatus.Closing]: 'warning',
    [ProductStatus.Draft]: 'info',
    [ProductStatus.Inactive]: 'none',
    [ProductStatus.Proposed]: 'info',
};

export const PRODUCT_STATUS_TRANSLATION_KEY_MAP: KeyValueObject<any> = {
    [ProductStatus.Active]: 'ENUM_PRODUCTSTATUS_ACTIVE',
    [ProductStatus.Blocked]: 'ENUM_PRODUCTSTATUS_BLOCKED',
    [ProductStatus.Cancelled]: 'ENUM_PRODUCTSTATUS_CANCELLED',
    [ProductStatus.Closing]: 'ENUM_PRODUCTSTATUS_CLOSING',
    [ProductStatus.Draft]: 'ENUM_PRODUCTSTATUS_DRAFT',
    [ProductStatus.Inactive]: 'ENUM_PRODUCTSTATUS_INACTIVE',
    [ProductStatus.Proposed]: 'ENUM_PRODUCTSTATUS_PROPOSED',
};
